import * as React from 'react';
import * as _ from 'lodash';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchProductWP } from '../actions/posts';
import { fetchCategoriesProductWP } from '../actions/categories';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import { getCookie } from '../helpers/index';

class Products extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true
		}
	}

	componentDidMount() {
		if (this.props.match.params.cate_id) {
			this.props.fetchProductWP({
				per_page: 100,
				category: this.props.match.params.cate_id
			});
		} else {
			this.props.fetchProductWP({
				per_page: 100
			});
		}
		this.props.fetchCategoriesProductWP({
			term: 'product_cat',
			number: 100
		});
		document.title = this.props.t('products');
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.match.params.cate_id && nextProps.match.params.cate_id != this.props.match.params.cate_id) {
			this.setState({
				loading: true
			});
			window.scrollTo(110, 110);
			this.props.fetchProductWP({
				per_page: 100,
				category: nextProps.match.params.cate_id
			});
		} else {
			if (nextProps.categoriesProductWP.loading == false && nextProps.productsWP.loading == false) {
				var element: any = document.getElementById('loading-data');
				element.innerHTML = '';
				this.setState({
					loading: false
				})
			}
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.productsWP.loading || nextProps.categoriesProductWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	allProduct = () => {
		var element: any = document.getElementById('loading-data');
		element.innerHTML = `<div class="loadingPage active"> <img src=${require('../img/Spin-1s-58px.gif')}></div>`;
		window.scrollTo(110, 110);
		this.props.fetchProductWP({
			per_page: 100
		});
	};

	render() {

		const { productsWP, categoriesProductWP } = this.props;

		var language = 'vn';

		if(getCookie('language_landing')) {
			language = getCookie('language_landing');
		}

		var filteredProduct = _.filter(productsWP.data, function (post) {
			return _.some(post.meta_data, { 'value': language, 'key': 'language' });
		});

		var products_div = filteredProduct.map(item => {
			var link = '';
			if (item.images.length > 0) {
				link = item.images[0]['src'];
			}
			return (
				<div key={item.id} className="col-6 col-sm-4">
					<div className="itemProducts">
						<Link to={`/product/${item.id}/${item.slug}`}>
			                  <span className="imgPrd">
			                    <img src={require('../img/img-maskPrd.png')}
			                         style={{ background: `url(${link}) no-repeat center center/cover` }}/>
			                  </span>
							<h2 className="itemTitle">{item.name}</h2>
						</Link>
					</div>
				</div>
			);
		});

		var filteredList = _.filter(categoriesProductWP.data, function (post) {
			return _.some(post.custom_fields, { 'value': language, 'key': 'language' });
		});

		var cate_name = filteredList.map(item => {
			var active = 'catItem';
			if (this.props.match.params.cate_id && this.props.match.params.cate_id == item.term_id) {
				active = 'catItem active';
			}
			return (
				<li key={item.term_id} className={active}><Link
					to={`/product-category/${item.term_id}/${item.slug}`}>{item.name}</Link></li>
			);
		});

		return (
			<div className="productsWrap">
				<div className="container">
					<div className="pageTitle">
						Cửa hàng
					</div>
					<div className="row">
						<div className="col-sm-3">
							<div className="sidebarProduct">
								<ul className="product-categories">
									<li onClick={this.allProduct}
									    className={window.location.pathname == '/products' ? 'catItem active' : 'catItem'}>
										<Link to={`/products`}>All</Link></li>
									{cate_name}
								</ul>
							</div>
						</div>
						<div className="col-sm-9">
							<div className="shopProducts">
								<div className="row">
									{products_div}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="loading-data"></div>
				{this.state.loading ? <div className="loadingPage active"> <img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'productsWP', 'categoriesProductWP'
]), mapDispatchToProps({
	fetchProductWP, fetchCategoriesProductWP
}))(translate('translations')(Products));



// WEBPACK FOOTER //
// ./src/containers/Products.tsx